import { useMemo } from "react";
import { LANGUAGES_MENU } from "../../../i18n/config";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeLanguagePop } from "../../../redux/action/member/memberAction";
import {
  AbsoluteCenter,
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { COMMON_WEB_PATH } from "../../../constant";

const LanguagePage = () => {
  const textActiveColor = useColorModeValue("dark.100", "light.100");

  const website_language = window.web_language || [];

  const memberData = useSelector((state) => state.isMemberInfo);
  const { test } = memberData || {};

  const language_filter = useMemo(() => {
    return LANGUAGES_MENU?.filter((item) => {
      if (test == 1) {
        return item;
      } else {
        return website_language?.includes(item.value);
      }
    });
  }, [test, website_language]);

  const onClose = async () => {
    await dispatch(closeLanguagePop());
  };

  const dispatch = useDispatch();
  return (
    <Modal
      variant={`brandPrimary`}
      onClose={onClose}
      isOpen={true}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent
        width={{
          md: "450px",
          base: "90%",
        }}
        height={{
          base: "400px",
          md: "520px",
        }}
        borderRadius={{
          base: "common",
        }}
        borderTopRadius={{
          md: "none",
        }}
        borderBottomRadius={{
          md: "common",
        }}
        my="auto"
        shadow="md"
        bgImage={`url(${COMMON_WEB_PATH}/now888/modal/hintBG.webp) !important`}
        bg={`url(${COMMON_WEB_PATH}/now888/modal/hintBG.webp) !important`}
        bgSize="100% 100% !important"
        bgPosition="center"
        pb="10px"
        pt={{
          base: "50px",
          md: "100px",
        }}
        position="relative"
      >
        <AbsoluteCenter
          top={{
            base: "15px",
            md: "15px",
          }}
        >
          <Image
            src={`${COMMON_WEB_PATH}/now888/lng/lng_title${
              i18next.language == "tw" ? "" : `_${i18next.language}`
            }.png`}
            w="200px"
          />
        </AbsoluteCenter>
        <Box
          onClick={onClose}
          position="absolute"
          top="0"
          right="0"
          w="60px"
          h="30px"
          cursor="pointer"
        ></Box>
        <ModalBody h={500} px="0" overflow="scroll">
          <Grid
            templateColumns={"repeat(1, minmax(0, 1fr))"}
            as="section"
            display="grid"
            flexDirection={`column`}
            //gap="10px"
            //borderRadius={`common`}
            py="8px"
            px="8px"
          >
            {language_filter?.map((item, index) => {
              return (
                <GridItem>
                  <Box
                    onClick={async (event) => {
                      event.stopPropagation();
                      await i18next.changeLanguage(item.value);
                      localStorage.setItem("i18nextLng", item.value);
                      // const targetPath = item.value === "tw" ? "" : item.value;
                      const targetPath = item.value;

                      window.location.assign("/" + targetPath);
                    }}
                    key={`${item.language}-${index}`}
                    cursor={`pointer`}
                    //borderRadius={`common`}
                    p="10px"
                    px="30px"
                    display="flex"
                    flexDirection={`row`}
                    alignItems={`center`}
                    justifyContent={`center`}
                    sx={{
                      bgImage:
                        i18next.language === item.value
                          ? `${COMMON_WEB_PATH}/now888/lng/hover_button.png`
                          : null,
                      bgSize: "contain",
                      bgPos: "center",
                      bgRepeat: "no-repeat",
                      _hover: {
                        bgImage: `${COMMON_WEB_PATH}/now888/lng/hover_button.png`,
                      },
                    }}
                    position="relative"
                    gap="20px"
                  >
                    <Flex alignItems={`center`} gap="15px">
                      {/* <Image
                        w="38px"
                        h="auto"
                        src={`https://flagsapi.com/${item.flag?.toUpperCase()}/flat/64.png`}
                      /> */}
                      <Flex alignItems={`center`} gap="5px">
                        {/* <Flag name={item.flag} className="!w-[20px]" height="15" /> */}
                        <Text
                          as="span"
                          fontWeight={`medium`}
                          fontSize={{
                            base: "20px",
                            md: "30px",
                          }}
                          color={textActiveColor}
                        >
                          {item.text}
                        </Text>
                      </Flex>
                    </Flex>
                  </Box>
                </GridItem>
              );
            })}
          </Grid>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LanguagePage;
